import { SitePropertiesService } from '@wix/ambassador-site-properties-service/http';
import { getInstanceForAuthorization } from '../instance-service/instance-service';
import { StoreState } from '@src/context/store';
import { getDefaultPolicy } from '@src/context/helpers/default-policy';

const service = SitePropertiesService('/_api/site-properties-service');

export const ensurePolicyInSiteSettings = async (store: StoreState) => {
  const headers = { Authorization: getInstanceForAuthorization() };

  return service
    .SitePropertiesV4()(headers)
    .update({
      properties: {
        consentPolicy: getDefaultPolicy(store),
      },
      fields: {
        paths: ['consentPolicy'],
      },
    });
};

export interface SiteSettingsService {
  ensurePolicyInSiteSettings(store: StoreState): Promise<any>;
}

export const siteSettingsService: SiteSettingsService = {
  ensurePolicyInSiteSettings,
};
